import React, { useState, useRef } from 'react'
import { useEnvValue } from '@morningtrain/react-helpers'
import { observer } from 'mobx-react'
import anime from 'animejs'
import classNames from 'classnames'

function ProductModal() {
  const [productModal] = useEnvValue('productModal')
  const [modalButtonIsVisible, setModalButtonIsVisible] = useState(true)
  const productModalRef = useRef(null)
  const bannerElement = productModal.banner ?? null
  const modalElement = productModal.modal ?? null
  const modalButtonClasses = classNames('mtt-product-modal-button-wrap', {
    'mtt-product-modal-button-wrap--visible': modalButtonIsVisible,
  })

  const handleOnClick = function (event) {
    event.preventDefault()
    const modal = productModalRef.current

    if (!modal) {
      return
    }

    anime({
      targets: modal.children[0],
      opacity: [0, 1],
      translateY: [-30, 0],
      duration: 300,
      easing: 'easeOutCubic',
      delay: 200
    })

    document.body.classList.add('modal-open')
    modal.classList.add('active')
  }

  return (
    <>
      {
        productModal.showModal === true && (
          <>
            <div className={modalButtonClasses}>
              <button onClick={handleOnClick} className="mtt-product-modal-button">
                <div
                  className="mtt-product-modal-button__image object-fit"
                  dangerouslySetInnerHTML={{__html: bannerElement?.image}}
                />
                <div className="mtt-product-modal-button__text">
                  <div className="tagline">{bannerElement.tagline}</div>
                  <div className="title">{bannerElement.title}</div>
                </div>
              </button>
              <button className="close-modal" onClick={() => setModalButtonIsVisible(!modalButtonIsVisible)}/>
            </div>
            <div className="modal-outer product-modal" id="product-modal" ref={productModalRef}>
              <div className="modal-inner product-modal-inner">
                <button className="close-modal"/>
                <div className="modal-inner-content">
                  <div className="product-modal-tagline">{modalElement.tagline}</div>
                  <h3 className="product-modal-title">{modalElement.title}</h3>
                  <div className="product-modal-subtitle">{modalElement.subtitle}</div>
                  <div
                    className="product-modal-description"
                    dangerouslySetInnerHTML={{__html: modalElement.description}}
                  />
                  <div
                    className={modalElement.showImageBackground ? 'product-modal-image show-background' : 'product-modal-image'}
                    dangerouslySetInnerHTML={{__html: modalElement.image}}
                  />
                </div>
              </div>
            </div>
          </>
        )
      }
    </>
  )
}

export default observer(ProductModal)